module.exports = __webpack_public_path__ + "static/media/info.646c850c.png";